import { useTranslation } from 'react-i18next'

import { Icon } from '@/components/icon'
import { Button } from '@/components/ui/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu'
import { cn } from '@/infra'

interface PainelAcoesProps {
  quantidadeSelecionada: number
  isLoading: boolean
  onDownload: () => void
  onCancelar: () => void
  midiaTipo: string
}

export const PainelAcoes = ({
  quantidadeSelecionada,
  isLoading,
  onDownload,
  onCancelar,
  midiaTipo,
}: PainelAcoesProps) => {
  const { t } = useTranslation('empreendimentos')

  const getSelectionText = () => {
    if (quantidadeSelecionada === 1) {
      return t('pages.midias.selecao.midia_selecionada_singular', { midiaTipo })
    }
    return t('pages.midias.selecao.midia_selecionada_plural', { quantidadeSelecionada, midiaTipo })
  }

  const getButtonWidth = () => (midiaTipo === 'foto' ? 'min-w-[220px]' : 'min-w-[240px]')

  return (
    <div className="fixed bottom-8 left-1/2 z-50 -translate-x-1/2 transform">
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild disabled={isLoading} className="data-[disabled]:opacity-100">
          <Button
            variant="default"
            className={cn(
              'font-poppins justify-between shadow-lg',
              getButtonWidth(),
              isLoading ? 'bg-neutral-500' : 'bg-neutral-800 hover:bg-neutral-800',
            )}
          >
            <span>{getSelectionText()}</span>
            <div className="ml-auto h-9 w-px bg-neutral-500" />
            <Icon name="chevron-down" size={20} className="text-neutral-50" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          className="font-nunito text-neutral-800"
          style={{ width: 'var(--radix-dropdown-menu-trigger-width)' }}
        >
          <DropdownMenuItem onClick={onDownload} disabled={isLoading}>
            <Icon name="download" size={20} />
            {t('pages.midias.acoes.baixar')}
          </DropdownMenuItem>

          <DropdownMenuItem onClick={onCancelar}>
            <Icon name="close" size={20} />
            {t('pages.midias.acoes.cancelar')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
